import { useState } from 'react';
import { LabelButton } from 'components/buttons/LabelButton/LabelButton';
import betinoTitle from 'images/betinoTitle .jpg';
import wuxalTitle from 'images/wuxalTitle.jpg';
import fertiplantTitle from 'images/fertiplantTitle.jpg';
import UniferXTitle from 'images/UniferXTitle.jpg';
import { Button } from 'components/buttons/Button/Button';
import './styles.scss';

const Products = () => {
    const [hovered, setHovered] = useState('');

    const handleMouseEnter = el => {
        setHovered(el);
    };

    const handleMouseLeave = () => {
        setHovered('');
    };

    return (
        <section className="container">
            <div className="our-products">
                <div className="products-button-wrapper">
                    <LabelButton>PRODUCTS</LabelButton>
                </div>
                <div className="our-products-wrapper">
                    <h2>
                        Our products
                        <br /> <span className="black-text">are more than just fertilizers</span>
                    </h2>
                    <div
                        // className="our-products-item first black-text"
                        className={`our-products-item first black-text ${
                            hovered && hovered !== 'first' && 'opacity-50'
                        }`}
                        onMouseEnter={() => handleMouseEnter('first')}
                        onMouseLeave={handleMouseLeave}
                    >
                        <h3>Organic line</h3>
                        <div>
                            <img src={betinoTitle} alt="Betino title" />
                        </div>
                        <Button type="learn-more-arrow" />
                    </div>
                    <div
                        className={`our-products-item second black-text ${
                            hovered && hovered !== 'second' && 'opacity-50'
                        }`}
                        onMouseEnter={() => handleMouseEnter('second')}
                        onMouseLeave={handleMouseLeave}
                    >
                        <h3>Wuxal</h3>
                        <div>
                            <img src={wuxalTitle} alt="Wuxal title" />
                        </div>
                        <Button type="learn-more-arrow" />
                    </div>
                    <div
                        className={`our-products-item third black-text ${
                            hovered && hovered !== 'third' && 'opacity-50'
                        }`}
                        onMouseEnter={() => handleMouseEnter('third')}
                        onMouseLeave={handleMouseLeave}
                    >
                        <h3>Fertiplant</h3>
                        <div>
                            <img src={fertiplantTitle} alt="Fertiplant title" />
                        </div>
                        <Button type="learn-more-arrow" />
                    </div>
                    <div
                        className={`our-products-item fourth black-text ${
                            hovered && hovered !== 'fourth' && 'opacity-50'
                        }`}
                        onMouseEnter={() => handleMouseEnter('fourth')}
                        onMouseLeave={handleMouseLeave}
                    >
                        <h3>UniferX</h3>
                        <div>
                            <img src={UniferXTitle} alt="UniferX title" />
                        </div>
                        <Button type="learn-more-arrow" />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Products;
